import nativeApi from '@/utils/native-api'

function updateHeaderRightBtn(params = {}, callBack) {
  nativeApi.invoke('updateHeaderRightBtn', params)

  if (callBack) {
    nativeApi.actions.headerRightBtnClick = callBack
  } else {
    nativeApi.actions.headerRightBtnClick = () => {
    }
  }
}

export default {
  methods: {
    setNavigationRightBtn({text = '', color = '#333333', callBack}) {
      setTimeout(() => {
        let params = {action: 'show', color}
        params.text = text

        updateHeaderRightBtn(params, callBack)
      }, 100)
    },
    hideNavigationRightBtn() {
      nativeApi.invoke('updateHeaderRightBtn', {action: 'hide'})
      nativeApi.actions.headerRightBtnClick = () => {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/setNavigationRightBtn.js